import configs from "../config";

const bpm = configs.bpm;

const umbrella = configs.umbrella;
const documentos = configs.documentos;
export const SERVER_DOCUMENTOS = documentos.host + documentos.prefix;
export const umbrellaHeader = umbrella;
export const config = configs;
export const serverBPM = bpm.host;
export const serverUrl2 = serverBPM + bpm.prefix;

export const BPM_DOCUMENT_IMAGE_ID =
  serverBPM + bpm.prefix + "smart-bpm/rest/attachment/download?uid={id}&type=";
export const BPM_DOCUMENT_PDF_ID =
  serverBPM +
  bpm.prefix +
  "smart-bpm/rest/attachment/download?uid={id}&type=pdf";

export const customUploadDocUrlViaCamunda =
  "/smartbpm/smart-bpm/rest/attachment/new";
export const bpmSSL = bpm.SSL;
export const bpmPort = bpm.port;
export const bpmHostSemPorta = bpm.hostSemPorta;
